import React, { useEffect, useState } from "react"
import { initFeClient, addMsg, getSiteGid, JSONParse } from 'src/_helpers'
import { DirectMessagingFEService } from 'src/_services'
import { useSelector } from 'react-redux'
export const Control = () => {
  var [socket, setSocket] = useState(null);
  const DMStore = useSelector((state) => state.DirectMessaging);
  useEffect(() => {
    if (DMStore && DMStore.status === 'DONE' && DMStore.token) {
      initWebSocket(DMStore.token)
    }
  }, [DMStore]);
  useEffect(() => {
    initData()
  }, []);
  const initData = () => {
    new DirectMessagingFEService({ page_size: 100 })
      .noError()
      .history(getSiteGid())
      .then(e => {
        initFeClient({
          ...e,
          message: e.msg.results,
          client_id: e.device_id,
          customer_name: e.customer_name,
          customer_phone: e.customer_phone,
          status: 'DONE'
        })
        // initWebSocket(e.token)
      }).catch(e => {
        if (e.status === 404) {
          initFeClient({
            message: [],
            client_id: '',
            name: '',
            phone: '',
            status: 'NEW'
          })
        }
      })
  }
  const initWebSocket = (token) => {
    // if (retryTime >= 5) {
    //   console.log('WebSocket is Error')
    //   return
    // }
    if (socket && socket.readyState === 1) {
      console.log('WebSocket is readly')
      return
    }
    // const token = '228ded51-7dd3-4a5a-bb71-a60759379023-IgE4l-rMKUNdlgV2hxkqcORwIiGyxAdEpho1LA0lzVBdvj2Kgz8GpCxr2JsSA7Xuo2hXGjKj4Utf1NmJBEQGfESl1kSgVj1BhSlNcJ6fX6fQoW50VJFTVNG9LeX7upcipVrPv0ImyYpdbKuJ7ClwFFJUASSnDmIm4Lr33nJG-MGT2rPVJc0yR-jzCpJoaS1neVgsMPSS'
    let url = `wss://imonqr.com:9999/ws/${token}`
    var initsocket = new WebSocket(url)
    setSocket(initsocket)
    initsocket.onopen = (e) => {
      console.log('WebSocket is opening', e)
    }

    initsocket.onmessage = (e) => {
      addMsg(JSONParse(e.data))
    }
    initsocket.onclose = (e) => {
      console.log('onclose', e)
      setTimeout(() => { initWebSocket(token) }, 5000)
    }
    initsocket.onerror = (e) => {
      console.log('Network is offline', e)
    }
  }
  return <>...</>;
};
